import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BehfaRoleService {

  constructor(private http:HttpClient) { }

  GetRecord():Observable<Array<BehfaRole_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/BehfaRole").pipe(
      map(data=>{
        return data as Array<BehfaRole_Interface>
      })
    )
  }

  GetSingle(id:number):Observable<BehfaRole_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/BehfaRole/GetSingle?id="+id).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  AddBehfaRole(model: BehfaRole_Interface):Observable<BehfaRole_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    model.create_user=''

    var body={
      id:model.id,
      title:model.title,
      dsc:model.dsc,
      create_user: ''
    }

    return this.http.post(environment.BaseUrl + "Daro/BehfaRole/Add",body,{headers}).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  EditBehfaRole(model: BehfaRole_Interface):Observable<BehfaRole_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body={
      id:model.id,
      title:model.title,
      dsc:model.dsc,
      create_user: ''
    }

    return this.http.post(environment.BaseUrl + "Daro/BehfaRole/Edit",body,{headers}).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  DeleteBehfaRole(id:number):Observable<BehfaRole_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/BehfaRole/Delete?id="+id).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  PriorityBehfaRole(id:number):Observable<BehfaRole_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/BehfaRole/Priority?id="+id).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

}
